import { render, staticRenderFns } from "./RecentMatchesView.vue?vue&type=template&id=8f246292&scoped=true"
import script from "./RecentMatchesView.vue?vue&type=script&lang=js"
export * from "./RecentMatchesView.vue?vue&type=script&lang=js"
import style0 from "./RecentMatchesView.vue?vue&type=style&index=0&id=8f246292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f246292",
  null
  
)

export default component.exports